import React from 'react';

import { Outlet } from 'react-router-dom';

import HubContainer from './HubContainer';
import InfoHubMenu from './InfoHubMenu';
import GroundSwitch from '../components/GroundSwitch';

// The info hub's shell, sibling in spirit to AdminLayout / AuthLayout but owned by this
// module. The hub's pages nest under it as a layout route, so the menu stays mounted — and
// doesn't refetch — while navigating between content pages.
//
// The window itself never scrolls: this is a full-height flex column with the menu as a fixed
// row and `<main>` as the only scroll container. That keeps the top bar from shifting when a
// short page (no scrollbar) gives way to a tall one (scrollbar) — the scrollbar lives inside
// the content pane, not on the window. Mirrors AdminLayout's approach.
//
// `bg-page` / `text-ink` resolve against whichever ground is live. There is no `dark:` variant
// anywhere in this module by design: paper and navy are peers, and a `dark:` prefix would
// encode one as a recolour of the other. See DESIGN.md, The Two Peer Grounds Rule.
const InfoHubLayout: React.FC = () => (
  <div className="flex h-screen flex-col bg-page font-ui text-ink">
    <InfoHubMenu />
    {/* The trailing padding clears the fixed ground switch. DESIGN.md names this exact
        hazard on the public site: at the foot of a page the viewport bottom and the
        document bottom are the same line, so without it the switch sits on top of the
        last row and takes its clicks. */}
    <main className="flex-1 overflow-y-auto pb-24">
      <HubContainer>
        <Outlet />
      </HubContainer>
    </main>

    {/* The ground switch rides the bottom-right corner rather than the top bar.
        It is a preference, not navigation — it is set once and then left alone —
        so it does not need to hold width in the chrome.

        Fixed to the viewport, not to `<main>`: the window itself never scrolls
        here (`<main>` is the only scroll container), so the control stays put
        without a scroll listener. It is last in the DOM, which puts it last in
        the tab order — right for something you set once. */}
    <div className="fixed bottom-5 right-5 z-30">
      <GroundSwitch />
    </div>
  </div>
);

export default InfoHubLayout;
